import axios from 'axios';

export interface ChangePasswordParams {
  newPassword: string;
  currentPassword: string;
}

export interface ChangeTimezoneParams {
  timezone: string;
}

export class UserApi {
  static readonly KEY = 'user';

  static async changePassword(params: ChangePasswordParams): Promise<void> {
    const { data } = await axios.post('/api/v1/user/change_password', params);

    return data.data;
  }

  static async changeTimezone(params: ChangeTimezoneParams): Promise<void> {
    const { data } = await axios.post('/api/v1/user/change_timezone', params);

    return data.data;
  }
}
